import { ca } from '@cian/analytics';
import { getCianAnalyticsObject } from '../../utils/analytics/getCianAnaliticsObject';

export function trackingShowFSKMortgageBanner() {
  const { page, user } = getCianAnalyticsObject();

  ca('eventSite', {
    name: 'soprevent',
    category: 'SpecialPromoLanding',
    action: 'show',
    label: 'top_menu_banner',
    page,
    user,
  });
}

export function trackingClickFSKMortgageBanner() {
  const { page, user } = getCianAnalyticsObject();

  ca('eventSite', {
    name: 'oldevent',
    category: 'SpecialPromoLanding',
    action: 'click',
    label: 'top_menu_banner',
    page,
    user,
  });
}
